import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { Modal, Box, Typography } from '@mui/material';

import { DashboardContainer } from '../../components/dashboard';
import EventContainer from '../../components/Events/EventContainer';
import { appConfig } from '../../constants/appConfig';
import { websocket_config } from '../../constants/wsConfig';
import instances from '../../constants/instances';
import FullLayout from '../../layouts/fullLayout';
import { useBoundStore } from '../../stores/index';

import Telematics from '../../assets/images/products-telematics.svg';
import Fleet from '../../assets/images/products-fleet.svg';
import Dispatch from '../../assets/images/products-dispatch.svg';
import Fuel from '../../assets/images/products-fuel.svg';
import GeoMarketing from '../../assets/images/products-geomarketing.svg';
import Kids from '../../assets/images/products-kids.svg';
import Sentry from '../../assets/images/products-sentry.svg';
import Staff from '../../assets/images/products-staff.svg';
import logoSmall from '../../assets/images/logoSmall.svg';
import Compass from '../../assets/images/products-compass.svg';
import Wrench from '../../assets/images/products-wrench.svg';
import { EventNote } from '@mui/icons-material';

const Products = () => {
  const modalOpen = JSON.parse(localStorage.getItem('modalOpen'));
  const setModalOpen = useBoundStore((state) => state.setModalOpen);
  const setAppConfig = useBoundStore((state) => state.setAppConfig);
  const setWsConfig = useBoundStore((state) => state.setWsConfig);

  const textPool = useBoundStore((state) => state.textPool);

  const handleInstanceSelection = (selectedInstance) => {
    setAppConfig(appConfig[selectedInstance.config]);
    setWsConfig(websocket_config.url[selectedInstance.config]);
    localStorage.setItem('modalOpen', 'false');
    localStorage.setItem(
      'selectedInstance',
      JSON.stringify([selectedInstance]),
    );
    setModalOpen(false);
    toast.success(
      `${textPool['Uygulamaya yönlendiriliyorsunuz.']} (${selectedInstance.name})`,
    );
    window.location.reload();
  };

  const productsData = [
    {
      title: 'Defterdar',
      icon: <EventNote sx={{ fontSize: '80px' }} color="secondary" />,
      to: '/definitions/dashboard',
    },
  ];

  return (
    <FullLayout>
      <Typography variant="h4" gutterBottom sx={{ paddingX: '1.25rem' }}>
        {textPool['Merhaba,'] +
          ` ${JSON.parse(localStorage.getItem('user'))?.username}!`}
      </Typography>
      <DashboardContainer data={productsData} />
      {/* <EventContainer /> */}
      <Modal open={modalOpen}>
        <Box
          style={{
            outline: 'none',
            position: 'absolute',
            top: '50%',
            left: '50%',
            borderRadius: 30,
            transform: 'translate(-50%, -50%)',
            width: 500,
            minHeight: 300,
            backgroundColor: 'white',
            boxShadow: 24,
            padding: 10,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        >
          <Typography
            variant="h5"
            color="initial"
            gutterBottom
            textAlign={'center'}
          >
            {textPool['Hangi uygulamaya giriş yapmak istiyorsunuz?']}
          </Typography>

          <div className="flex flex-wrap w-full justify-center items-center mb-3">
            {instances.map((instance, index) => (
              <div
                key={index}
                className="flex flex-col w-36 justify-center items-center p-2 m-5 cursor-pointer hover:scale-110 transition ease 1s drop-shadow-2xl shadow-lg rounded-lg"
                onClick={() => handleInstanceSelection(instance)}
              >
                <span className="font-semibold m-5">{instance.name}</span>
              </div>
            ))}
          </div>
          <div className="flex justify-end items-center">
            <img className="mr-5 w-24" src={logoSmall} alt="Yerlem" />
          </div>
        </Box>
      </Modal>
    </FullLayout>
  );
};

export default Products;
